import { Box, Card, CardHeader, Stack } from '@mui/material'
import { memo } from 'react'
import { faTreasureChest } from '@fortawesome/pro-duotone-svg-icons'

import { formatTicks } from '../../util/string.helpers'
import FaIcon from 'src/components/shared/faIcon/FaIcon'
import CustomProgressBar from '../shared/progressBar/CustomProgressBar'
import ProgressTitle from '../shared/progressBar/ProgressTitle'
import { percentageOfCompletion } from '../../util/number.helpers'
import {
  getMilestoneInfo,
  INVITE_REFERRAL
} from '../../util/inviteFriends.helpers'
import { Label } from '../shared/label'
import ProviderIcon from '../shared/exchangeProviderCard/ProviderIcon'

const Milestones = ({ t, symbol, rewardedCount, referralMulti }) => {
  const { progress, nextMilestone, bonusAmount } = getMilestoneInfo({
    rewardedCount,
    referralMulti
  })
  const bonusValue = formatTicks(bonusAmount)
  return (
    <Card>
      <CardHeader
        title={t('reward-box.milestones')}
        subheader={t('referral.milestones-desc', {
          symbol,
          bonus: bonusValue,
          milestone: INVITE_REFERRAL.N_MILESTONE
        })}
      />
      <Box sx={[{ gap: 2, display: 'flex', alignItems: 'center', p: 3 }]}>
        <ProviderIcon
          icon={
            <FaIcon
              icon={faTreasureChest}
              style={{
                fontSize: 36,
                color: 'var(--palette-primary-main)'
              }}
            />
          }
          sx={{
            backgroundColor: 'rgba(var(--palette-primary-mainChannel) / 0.16)'
          }}
          variant='rounded'
          noBorder
        />
        <CustomProgressBar
          title={
            <ProgressTitle
              name={
                <Stack spacing={1} direction='row'>
                  {t('referral.next-milestone', {
                    count: nextMilestone
                  })}
                </Stack>
              }
            />
          }
          label={`${t('referral.progress')}: ${progress} / ${INVITE_REFERRAL.N_MILESTONE}`}
          completed={percentageOfCompletion(
            progress,
            INVITE_REFERRAL.N_MILESTONE
          )}
          rightLabel={
            <Label color='primary'>
              {t('referral.bonus')}: {bonusValue} {symbol}
            </Label>
          }
          height={10}
          progressTextSx={{ fontWeight: 600 }}
        />
      </Box>
    </Card>
  )
}

export default memo(Milestones)
